import TrezorConnect, { DEVICE, DEVICE_EVENT, EthereumAddress } from 'trezor-connect';
import Web3ProviderEngine from 'web3-provider-engine';
import { getProviderEngine, getRpcProvider } from './utils';
import TrezorSubprovider from './trezorSubprovider';
import { TREZOR_PATHS, TREZOR_LS_KEY } from '../constants/wallet';
import { stateEventObserver } from './EventObserver';
import EventTypes from '../constants/eventTypes';

TrezorConnect.manifest({
  appUrl: 'https://www.dcentralab.com/',
  email: 'aydnep@aydnep.com.ua',
});

const onTrezorEvent = (event: { type: string; }) => {
  if (event.type === DEVICE.DISCONNECT) {
    stateEventObserver.emit(EventTypes.DISCONNECT, null);
    TrezorConnect.off(DEVICE_EVENT, onTrezorEvent);
  }
};

export const removeTrezorEventListeners = () => {
  TrezorConnect.off(DEVICE_EVENT, onTrezorEvent);
};

type TGetTrezorProvider = (trezorPath: string, networkId: number, rpcUrl: string, savePath: boolean) => Promise<{
  provider: Web3ProviderEngine,
  trezorPath: string
}>;

export const getTrezorProvider: TGetTrezorProvider = async (trezorPath: string, networkId: number, rpcUrl: string, savePath: boolean) => {
  const options = {
    chainId: networkId,
    path: trezorPath, // || HD_DERIVATION_PATHS.LIVE.value
  };
  const [ProviderEngine, rpcProvider] = await Promise.all([getProviderEngine(), getRpcProvider(rpcUrl)]);
  const engine = new ProviderEngine();
  // @ts-ignore TODO: REWRITE TO CLASS?
  const trezorProvider = new TrezorSubprovider(options);
  engine.addProvider(trezorProvider);
  engine.addProvider(rpcProvider);
  engine.start();
  engine.isTrezor = true;
  if (savePath) {
    localStorage.setItem(TREZOR_LS_KEY, trezorPath);
  }
  TrezorConnect.on(DEVICE_EVENT, onTrezorEvent);
  return { provider: engine, trezorPath };
};

export const getTrezorAccount = async (offset: number, derivationPath: string) => {
  const bundle = [];
  const path = derivationPath || TREZOR_PATHS.LIVE.value;

  for (let i = 0; i < 5; i += 1) {
    bundle.push({
      path: path.replace('/x', `/${offset + i}`),
      showOnTrezor: false,
    });
  }

  const { success, payload } = await TrezorConnect.ethereumGetAddress({ bundle });
  if (!success) {
    const erroredPayload = payload as { error: string, code?: string };
    throw new Error(erroredPayload.error);
  }
  const googPayload = payload as EthereumAddress[];
  return googPayload.map(({ address }) => address);
};
